import React, { createContext, useContext, useState } from 'react';

const EstablishmentContext = createContext();

export const useEstablishment = () => useContext(EstablishmentContext);

export const EstablishmentProvider = ({ children }) => {
  const [establecimiento, setEstablecimiento] = useState(null);

  return (
    <EstablishmentContext.Provider value={{ establecimiento, setEstablecimiento }}>
      {children}
    </EstablishmentContext.Provider>
  );
};

//import React, { createContext, useContext, useState, useEffect } from 'react';
//import EstablecimientoService from '../services/establecimiento.service';
//
//const EstablishmentContext = createContext();
//
//export const useEstablishment = () => useContext(EstablishmentContext);
//
//export const EstablishmentProvider = ({ children }) => {
//  
//  const [establecimiento, setEstablecimiento] = useState(null);
//
//	//guarda el valor del establecimiento en el localStorage
//	useEffect(() => {
//		// carga la lista de establecimientos
//		const obtenerEstablecimientoPorDefecto= async () => {
//			await EstablecimientoService.getEstablecimientos()
//				.then(response => response.json())
//				.then(data => setEstablecimiento(data[0]));
//				//localStorage.setItem('establecimiento', JSON.stringify(establecimiento[0]));
//
//		}
//
//		obtenerEstablecimientoPorDefecto();
//	}, []);
//	
//	useEffect(() => {
//    if (establecimiento) {
//      localStorage.setItem('establecimiento', JSON.stringify(establecimiento));
//    }
//  }, [establecimiento]);
//
//  return (
//    <EstablishmentContext.Provider value={{ establecimiento, setEstablecimiento }}>
//      {children}
//    </EstablishmentContext.Provider>
//  );
//};



